import { useTranslation } from "react-i18next";
import { CheckCircle, XCircle } from "lucide-react";
import {
  BaseTrueFalseQuestionDto,
  StudentAssignmentDetailTeacherPerspectiveResponseDtoQuestionsWithStudentAnswersItem,
} from "@packages/api/madlenAPI.schemas";
import { Text } from "../../../../../core";

interface TrueFalseOptionProps {
  value: boolean;
  question:
    | BaseTrueFalseQuestionDto
    | StudentAssignmentDetailTeacherPerspectiveResponseDtoQuestionsWithStudentAnswersItem;
}

export const TrueFalseOption = ({ value, question }: TrueFalseOptionProps) => {
  const { t } = useTranslation();
  const isTeacherView = "studentAnswer" in question;

  const correctAnswer = isTeacherView
    ? (question.question as BaseTrueFalseQuestionDto).answer
    : (question as BaseTrueFalseQuestionDto).answer;

  const studentAnswer = isTeacherView
    ? (question.studentAnswer as boolean)
    : null;

  const getOptionStyle = () => {
    if (!isTeacherView) {
      return value === correctAnswer
        ? "bg-green-50 border-green-200 text-green-700 dark:bg-green-900/30 dark:border-green-800 dark:text-green-200"
        : "bg-white border-gray-200 text-gray-700 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200";
    }

    // Teacher view styling
    if (value === correctAnswer) {
      return "bg-green-50 border-green-200 text-green-700 dark:bg-green-900/30 dark:border-green-800 dark:text-green-200";
    }
    if (value === studentAnswer && value !== correctAnswer) {
      return "bg-red-50 border-red-200 text-red-700 dark:bg-red-900/30 dark:border-red-800 dark:text-red-200";
    }
    return "bg-white border-gray-200 text-gray-700 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200";
  };

  return (
    <div
      className={`flex-1 py-2 px-4 rounded-md border text-center transition-colors flex items-center justify-center gap-2 ${getOptionStyle()}`}
    >
      {value ? (
        <CheckCircle className="w-4 h-4" />
      ) : (
        <XCircle className="w-4 h-4" />
      )}
      {t(`assignments.generator.preview.${value ? "true" : "false"}`)}
      {isTeacherView && value === studentAnswer && (
        <Text variant="span" className="ml-2 text-sm">
          assignments.student.studentChoice
        </Text>
      )}
    </div>
  );
};
